import { validateForm } from '../main';

$(function () {
  $('.contactModalButton button').click(function () {
    $('.js-contact-modal.' + $(this).closest('.contactModalButton').prop('id')).toggleClass('show');
  });

  $('.js-contact-modal .callbackwish input').change(function () {
    const $checkbox = $(this);
    const tel = $('.tel', $(this).closest('.js-contact-modal'));
    const callbackFrom = $('.tel-from', $(this).closest('.js-contact-modal'));
    const callbackUntil = $('.tel-until', $(this).closest('.js-contact-modal'));
    const inputs = tel.find('input');

    if ($checkbox[0].checked) {
      tel.addClass('show');
      callbackFrom.addClass('show');
      callbackUntil.addClass('show');
      inputs.attr('required', 'required');
    } else {
      tel.removeClass('show');
      callbackFrom.removeClass('show');
      callbackUntil.removeClass('show');
      inputs.removeAttr('required');
    }
  });

  $('.js-contact-modal .is-customer input').change(function () {
    const $checkbox = $(this);
    const accountContainer = $('.account', $checkbox.closest('.js-contact-modal'));
    if ($checkbox[0].checked) {
      accountContainer.addClass('show');
      accountContainer.find('input, select').attr('required', 'required');
    } else {
      accountContainer.removeClass('show');
      accountContainer.find('input, select').removeAttr('required');
    }
  });

  $('.js-contact-modal .js-form-close').click(function () {
    $('.' + $(this).closest('.js-contact-modal').prop('id')).removeClass('show');
  });

  $('.js-contactModalSuccess .js-form-close').click(function () {
    $('.' + $(this).closest('.js-contactModalSuccess').prop('id')).removeClass('show');
  });

  $('.js-contact-modal form').on('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $form = $(this);
    const $submitButton = $form.find('[type="submit"]');
    if (validateForm($form)) {
      const data = $form.serialize();
      $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: data,
        success: function () {
          const forwardSummary = $submitButton.data('summaryForward');
          if (forwardSummary) {
            //Direkte Weiterleitung auf eigenständige Dankesseite
            location.href = forwardSummary;
          } else {
            $('.' + $form.closest('.js-contact-modal').prop('id')).toggleClass('show');
          }
        },
        error: function () {
          alert($form.closest('.js-contact-modal').attr('data-errormessage'));
        },
      });
    }
  });
});
